import { Box, Text } from '@chakra-ui/react';

export const RadioPreview = () => {
  return (
    <Box>
      <Text>RadioPreview - Coming soon</Text>
    </Box>
  );
};
